import React, { createContext } from "react";

import { App } from "../interfaces/app";
import { isAuthenticated, logout, login, isWelcome } from "../services/auth";

export interface AppProps extends App {}

export const AppContextDefaultValue = {
  isAuth: isAuthenticated(),
  error: false,
  loading: true,
  isWelCome: isWelcome(),
  user: {
    name: "",
    email: "",
    photo: "",
    cic: "",
    phone: "",
  },
  login: (token: string) => login(token),
  isAuthenticated: () => isAuthenticated(),
  logout: () => logout(),
  refreshUser: () => {},
  setWelcome: () => {},
};

export const AppContext = createContext<App>(AppContextDefaultValue);

export const injectContext = <P extends Object>(
  Component: React.ComponentType<P & App>
): React.FC<P> => (props) => (
  <AppContext.Consumer>
    {(value) => <Component {...value} {...props} />}
  </AppContext.Consumer>
);

export default injectContext;
